var _path, _g, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEmailPdf = function SvgEmailPdf(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 152 134"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M19 109a4 4 0 0 1-4-4V13a4 4 0 0 1 4-4h32.198l81.817.295a4 4 0 0 1 3.985 4V105a4 4 0 0 1-4 4z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#email-pdf_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M16 9a1 1 0 0 0-1 1v3l.702-1.052a2 2 0 0 1 3.02-.36l56.21 51.834a2 2 0 0 0 2.705.005l56.108-51.322a2 2 0 0 1 3.036.4l.219.343V9.999a1 1 0 0 0-1-1z",
    clipRule: "evenodd"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#9A9EAB",
    d: "M68.121 32.032h-3.16v1.97h3.716V35h-4.838v-6.798h4.838v.997H64.96v1.88h3.161zm1.633-1.79h.725l.136.68h.068q.532-.795 1.575-.794 1.166 0 1.688.861h.057q.52-.86 1.631-.86.918 0 1.428.588.52.578.521 1.553V35h-1.11v-2.63q0-.566-.295-.929-.283-.362-.816-.362-.52 0-.815.317a1.25 1.25 0 0 0-.317.76V35h-1.11v-2.742q0-.52-.295-.85-.295-.328-.828-.328-.52 0-.815.328a1.24 1.24 0 0 0-.317.748V35h-1.11v-4.76ZM82.836 35h-.77l-.136-.623h-.057q-.453.736-1.575.736-.826 0-1.303-.419a1.4 1.4 0 0 1-.475-1.088q0-.724.555-1.144t1.608-.42q.566 0 1.088.16v-.16q0-.996-1.235-.996-.317 0-.646.09-.317.08-.475.17l-.159.091-.385-.838q.69-.43 1.835-.43 1.054 0 1.586.52.544.51.544 1.416zm-2.288-.68q.51 0 .85-.294a1.02 1.02 0 0 0 .373-.737v-.385q-.363-.18-.963-.181-1.224 0-1.224.815a.72.72 0 0 0 .261.567q.26.215.703.215m4.156-4.95a.69.69 0 0 1-.487-.194.65.65 0 0 1-.193-.475q0-.285.193-.476a.69.69 0 0 1 .487-.193.66.66 0 0 1 .487.193.63.63 0 0 1 .204.476.63.63 0 0 1-.204.476.66.66 0 0 1-.487.192Zm-.555.871h1.11V35h-1.11v-4.76Zm2.512-2.096h1.11V35h-1.11z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#427CFF",
    d: "M73.94 133.06a1.5 1.5 0 0 0 2.12 0l9.546-9.546a1.5 1.5 0 1 0-2.121-2.121L75 129.878l-8.486-8.485a1.5 1.5 0 1 0-2.12 2.121l9.545 9.546ZM73.5 86v45.999h3v-46h-3Z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "email-pdf_svg__a",
    width: 150.849,
    height: 83.801,
    x: 0.576,
    y: 0.575,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.212
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.258824 0 0 0 0 0.486275 0 0 0 0 1 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_279_11666"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_279_11666",
    result: "shape"
  })))));
};
export { SvgEmailPdf as ReactComponent };